//TODO: navlink 사용하기 (추후에) 24.02.08

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import styled from '@emotion/styled';
import { icons } from '@assets/icons';
import { getFetcher, PRODUCT_TITLE } from '../../../App';
import { PrimaryButton } from '@components/atoms';
import { useSetRecoilState } from 'recoil';
import { dialogContentsState } from '@components/templates/Dialog';

interface DefaultNavProps {
  name: string;
  location: string;
  submenu?: DefaultNavProps[] | string | RegExp;
}

interface NavItemProps {
  icons?: any[];
}

type NavListProps = DefaultNavProps &
  NavItemProps & {
    submenu?: DefaultNavProps[];
  };

type ResponseMenuData = {
  enable: boolean;
  iconName: string[];
  id: number;
  name: string;
  orderSeq: number;
  routePath: string;
  subMenuList: ResponseMenuData[] | [];
  upperMenuId: number | null;
};

const SideNavigationBar = () => {
  const { pathname } = useLocation();
  const setDialogContents = useSetRecoilState(dialogContentsState);
  const [navList, setNavList] = useState<NavListProps[]>();

  const handleMenu = (e: any) => {
    const navItems = e.target.parentElement.children;
    if (navItems && navItems.length > 0) {
      for (let child of navItems) {
        child.dataset.active = '';
      }
    }
    e.target.dataset.active = 'true';

    const navItemInnerList = e.target.children;
    if (!navItemInnerList || navItemInnerList.length === 0) return;
    for (let navItemInner of navItemInnerList) {
      if (navItemInner.tagName.toUpperCase() === 'LI' && navItemInner.children.length > 0) {
        for (let navSubItem of navItemInner.children) {
          navSubItem.dataset.active = '';
        }
        navItemInner.children[0].dataset.active = 'true';
      }
    }
  };

  /**
   * 메뉴 데이터 없을 경우 경고
   */
  const noneMenuData = () => {
    setDialogContents({
      type: 'plain',
      body: 'Failed load Menu Data.',
      footer: (
        <>
          <PrimaryButton
            onClick={async () => {
              setDialogContents({ type: 'hidden' });
            }}
          >
            OK
          </PrimaryButton>
        </>
      ),
    });
  };

  /**
   * 메뉴 동적 생성 - 재귀함수
   * @param response
   */
  const makeMenuItem = (response: ResponseMenuData[]) => {
    const _menu: NavListProps[] = [];

    response &&
      response.forEach((menu: ResponseMenuData) => {
        if (menu.enable) {
          // @ts-ignore
          const _icon = [icons[`${menu.iconName}_off`], icons[`${menu.iconName}`]];

          let _tmpMenu: NavListProps = {
            name: menu.name.replace('&#40;', '(').replace('&#41;', ')'),
            location: menu.subMenuList.length > 0 ? menu.subMenuList[0].routePath : menu.routePath,
            icons: _icon,
            ...(menu.subMenuList.length > 0 ? { submenu: makeMenuItem(menu.subMenuList) } : {}),
          };
          _menu.push(_tmpMenu);
        }
      });

    return _menu;
  };

  /**
   * 메뉴 데이터 가져오기
   */
  const getMenuData = async () => {
    const url = `api/menu`;
    const token = localStorage.getItem('PROD_ADMIN_ACCESS_TOKEN') || undefined;

    await getFetcher({
      method: 'GET',
      accessToken: token,
    })(url)
      .then(async (r) => {
        if (r.code !== '200') {
          if (r.code !== 'UNAUTHORIZED') noneMenuData();
          return;
        }
        const _resultMenu = makeMenuItem(r.result);
        setNavList(_resultMenu);
      })
      .catch((e) => {
        noneMenuData();
      });
  };

  /**
   * 진입시 메뉴 데이터 호출 및 동적 생성
   */
  useEffect(() => {
    (async () => {
      await getMenuData();
    })();
  }, []);

  return (
    <>
      <NavList>
        {navList &&
          navList.map((navItem: NavListProps) => {
            return (
              <NavItem
                key={uuid()}
                onClick={(e) => handleMenu(e)}
                {...{ icons: navItem.icons }}
                data-href={navItem.location}
                data-active={`${pathname.startsWith(navItem.location)}`}
              >
                <NavItemLabel>{navItem.name}</NavItemLabel>
                {navItem.submenu && (
                  <NavSubList>
                    {navItem.submenu.map((navSub) => {
                      const divide = pathname.split('/');
                      const fstName = divide[1];
                      const subName = divide[2];
                      const pattern = new RegExp(`${navSub.name.toLowerCase()}`, 'i');

                      //Todo 임시 방편 - super 관리자 transfer 메뉴 하위 일 경우도 상위 선택 노출
                      const isTransferMenu =
                        navSub.location === '/transfer' &&
                        (pathname.includes('/sending') || pathname.includes('/receiving'));
                      //Todo 임시 방편 -  admin 관리자 permissions 메뉴 하위 일 경우도 상위 선택 노출
                      const isPermissionMenu = navSub.location === '/permissions' && pathname.includes('/detail');

                      return (
                        <NavSubItem
                          key={uuid()}
                          data-location={navSub.location}
                          data-active={`${
                            pathname === navSub.location ||
                            (navSub.submenu as RegExp)?.test(pathname) ||
                            isTransferMenu ||
                            isPermissionMenu ||
                            pattern.test(subName)
                          }`}
                        >
                          {navSub.name}
                        </NavSubItem>
                      );
                    })}
                  </NavSubList>
                )}
              </NavItem>
            );
          })}
      </NavList>
    </>
  );
};

const NavList = styled.ul`
  width: 240px;
  margin-top: 40px;
  ::marker {
    content: '';
  }
`;

const NavItem = styled.li`
  margin: 10px 0;
  cursor: pointer;
  position: relative;
  color: #555;
  & > div {
    display: flex;
    align-items: center;
    position: relative;
    ::before {
      margin-right: 10px;
      width: 24px;
      height: 24px;
      content: url(${(props: NavItemProps) => props.icons && props.icons[0]});
    }
  }

  :hover {
    & > div {
      color: #00bf00;
      ::before {
        content: url(${(props: NavItemProps) => props.icons && props.icons[1]});
      }
    }
  }

  &[data-active='true'] {
    &::before {
      position: absolute;
      content: '';
      width: 4px;
      height: 40px;
      background-color: #00bf00;
      left: 0;
    }

    & > div {
      color: #00bf00;
      background: rgba(127, 226, 0, 0.1);
      ::before {
        content: url(${(props: NavItemProps) => props.icons && props.icons[1]});
      }
    }

    ul {
      display: block;
    }
  }
`;

const NavItemLabel = styled.div`
  display: flex;
  align-items: center;
  padding-left: 40px;
  z-index: -1;
  position: relative;
  height: 40px;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 30px;
  ::before {
  }
`;

const NavSubList = styled.ul`
  margin-top: 10px;
  ::marker {
    content: '';
  }
  display: none;
`;

const NavSubItem = styled.li`
  height: 30px;
  margin-left: 40px;
  padding-left: 20px;
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #999;
  line-height: 30px;
  :hover {
    color: #00bf00;
    background: #fafafa;
  }
  &::before {
    position: absolute;
    content: '';
    width: 2px;
    height: 30px;
    background-color: #e0e0e0;
    left: 0;
  }
  &[data-active='true'] {
    color: #00bf00;
    font-weight: bold;
  }
`;

export default SideNavigationBar;
